<script setup lang="ts">
import { computed } from 'vue'
import { type MetaBreadcrumbs, useMeta, useTranslate } from '@/shared/lib'
import { VIcons } from '@/shared/ui'

const meta = useMeta()
const { trs } = useTranslate()

const breadcrumbs = computed(() => {
  const result: (MetaBreadcrumbs | string)[] = []

  meta.data.breadcrumbs?.forEach((item) => {
    if (typeof item === 'string') {
      result.push(trs(item))
    } else {
      result.push({
        title: trs(item.title),
        to: item.to || '',
      })
    }
  })

  return result
})
</script>

<template>
  <VBreadcrumbs :items="breadcrumbs">
    <template v-slot:item="{ item }">
      <RouterLink class="v-breadcrumbs-item--link" :to="item.to" v-if="item.to">
        {{ item.title }}
      </RouterLink>

      <div class="v-breadcrumbs-item v-breadcrumbs-item--disabled" v-else>
        <VIcons class="w-content-header__icon" :type="meta.data.icon" />
        {{ item.title }}
      </div>
    </template>
  </VBreadcrumbs>
</template>
